import { every, omit } from "lodash";
import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

type UseValidateMutualExclusionProps = {
  fieldPrefix: string;
  template: FiltersConfigTemplateElement;
};

type Value = boolean | string | number;

const isMatching = (ruleValue: Value | Value[], propertyValue: Value): boolean =>
  Array.isArray(ruleValue) ? ruleValue.includes(propertyValue) : ruleValue === propertyValue;

export const useValidateMutualExclusion = ({ fieldPrefix, template }: UseValidateMutualExclusionProps) => {
  const { watch } = useFormContext();

  const validateMutualExclusion = useCallback(
    (property: string, value: Value): string | null => {
      const mutuallyExclusiveValuesRules = template.mutually_exclusive_values;

      const relevantRules = (mutuallyExclusiveValuesRules || []).filter(({ rule }) =>
        Object.keys(rule).includes(property)
      );

      const matchingRule = relevantRules.find(({ rule }) => {
        if (isMatching(rule[property], value)) {
          return every(Object.keys(omit(rule, [property])), (key) =>
            isMatching(rule[key], watch(`${fieldPrefix}.${key}`))
          );
        }
      });

      return matchingRule?.error_message || null;
    },
    [fieldPrefix, template, watch]
  );

  return validateMutualExclusion;
};
